import { ItemList } from '../../orm'
import { download } from '../../actions/lib'

class AdminNumberReportList extends ItemList {
    getEntityKey() {
        return "admin/number_report/generate"
    }

    createListReport({filter}) {
        return this.saveNewObject({filter:filter, report_type: 'list'})
    }

}

export const adminNumberReportList = new AdminNumberReportList("admin_number_report__default")
